(function () {
  var STORAGE_KEY = 'lushe:wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    document.dispatchEvent(new CustomEvent('lushe:wishlist:updated', { detail: { ids: ids } }));
  }

  function toggle(id) {
    var ids = getWishlist();
    var index = ids.indexOf(id);
    if (index > -1) {
      ids.splice(index, 1);
    } else {
      ids.push(id);
    }
    saveWishlist(ids);
  }

  function refreshUI() {
    var ids = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var id = button.getAttribute('data-product-id');
      button.classList.toggle('is-active', ids.indexOf(id) > -1);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = ids.length;
      el.hidden = ids.length === 0;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    toggle(button.getAttribute('data-product-id'));
    refreshUI();
  });

  document.addEventListener('lushe:wishlist:updated', refreshUI);
  document.addEventListener('DOMContentLoaded', refreshUI);
  refreshUI();
})();
